export default [
  { path: '/document', 
    name: 'DocumentList', 
    component: () => import('@/views/document/List'),
    meta: {
      breadcrumbs: [
        { text: 'เอกสาร', disabled: true }
      ]
    }
  },
  { 
    path: '/document/create', 
    name: 'DocumentCreate', 
    component: () => import('@/views/document/Form'),
    meta: { 
      form_type: 'CREATE', 
      form_title: 'สร้าง',
      breadcrumbs: [
        { text: 'เอกสาร', to: `/document` },
        { text: `สร้างเอกสาร` },
      ]
    }, 
  },
  { 
    path: '/document/:id/edit', 
    name: 'DocumentEdit', 
    component: () => import('@/views/document/Form'),
    meta: { 
      form_type: 'EDIT', 
      form_title: 'แก้ไข',
      breadcrumbs: [
        { text: 'เอกสาร', to: `/document` },
        { text: `แก้ไขเอกสาร` },
      ]
    }, 
  }
]